import React from "react";
import './sideMenu.scss';
import MenuContainer from "../menu/MenuContainer";

const SideMenu = ({onUrlChange}) => {
    return (
        <div>
            <MenuContainer onUrlChange={onUrlChange} />
        </div>
    )
}

export default SideMenu;